import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'
// 获取车品牌信息
const getBrandInfo = async () => {
  try {
    const json = await fetch(
      getUrl(
        '/motor/brand/v4/brand/?hot_brand=0&no_sales=1&is_config=0&version_code=476&version_name=4.7.6'
      )
    )
    return json.data?.filter((item: any) => item.type === '1001')
  } catch (error) {
    console.error(error)
    return []
  }
}

export default getBrandInfo
